import React, { useState, useEffect } from "react"
import { Icon, Button, Modal, Table, Input, Radio } from "semantic-ui-react"
import { isEqual, cloneDeep, isEmpty } from 'lodash'
import fire from '../App/fire';

const GlipNotificationsModal = (props) => {
  let initFields
  const [disableSave, setDisableSave] = useState(false)

  // Getting data from firebase
  fire
    .database()
    .ref('glipwebhooks')
    .orderByKey()
    .on('value', snapshot => {
      initFields = snapshot.val()
    });

  const [fields, setFields] = useState(initFields)

  useEffect(() => {
    if (!fields && initFields) {
      setFields(initFields)
    }
    // eslint-disable-next-line
  }, [initFields])

  const handleActive = (updatedFieldIndex) => {
    let updatedFields = cloneDeep(fields)
    updatedFields[updatedFieldIndex].active = !updatedFields[updatedFieldIndex].active
    setFields(updatedFields)
  }

  const handleDelete = (deletedFieldIndex) => {
    // prevent deleting last record
    if (fields.length === 1) {
      return false
    }

    const filtered = fields.filter((field, index) => index !== deletedFieldIndex)

    // automatically set the default webhook
    if (filtered.length === 1) {
      filtered[0].active = true
    }
    setFields(filtered)
  }

  const handleChangeInput = (event, index, key) => {
    const updatedFields = cloneDeep(fields)
    updatedFields[index][key] = event.target.value
    setDisableSave(isEmpty(updatedFields[index].name) || isEmpty(updatedFields[index].url))
    setFields(updatedFields)
  }

  const handleAddWebhook = () => {
    const updatedField = cloneDeep(fields)
    updatedField.push({ name: '', message: '', icon_url: '', url: '', active: false })
    setDisableSave(true)
    setFields(updatedField)
  }

  const handleSave = () => {
    fire
      .database()
      .ref('glipwebhooks')
      .set(fields);

    props.onCloseGlipConfig()
  }

  return (
    <Modal
      onClose={() => {
        setFields(initFields || [])
        setDisableSave(false)
        props.onCloseGlipConfig()
      }}
      open={props.open}
      closeIcon
    >
      <Modal.Header>
        <Icon name="setting" />
        Glip Webhooks
      </Modal.Header>
      <Modal.Content>
        <Table compact celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>Message</Table.HeaderCell>
              <Table.HeaderCell>Avatar URL</Table.HeaderCell>
              <Table.HeaderCell>Webhook URL</Table.HeaderCell>
              <Table.HeaderCell>Active</Table.HeaderCell>
              <Table.HeaderCell>Delete</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {
              !isEmpty(fields) && fields.map((field, index) => (
                <Table.Row key={index}>
                  <Table.Cell>
                    <Input value={field.name} onChange={(e) => handleChangeInput(e, index, 'name')} fluid />
                  </Table.Cell>
                  <Table.Cell>
                    <Input value={field.message} onChange={(e) => handleChangeInput(e, index, 'message')} fluid />
                  </Table.Cell>
                  <Table.Cell>
                    <Input value={field.icon_url} onChange={(e) => handleChangeInput(e, index, 'icon_url')} fluid />
                  </Table.Cell>
                  <Table.Cell>
                    <Input value={field.url} fluid onChange={(e) => handleChangeInput(e, index, 'url')} />
                  </Table.Cell>
                  <Table.Cell textAlign='center' width={1}>
                    <Radio toggle checked={field.active} onClick={() => handleActive(index)} />
                  </Table.Cell>
                  <Table.Cell textAlign='center' width={1}>
                    <Button size='small' color='red' icon='trash' onClick={() => handleDelete(index)} />
                  </Table.Cell>
                </Table.Row>
              ))
            }
          </Table.Body>
          <Table.Footer fullWidth>
            <Table.Row>
              <Table.HeaderCell colSpan='6'>
                <Button
                  floated='right'
                  icon
                  labelPosition='left'
                  primary
                  size='small'
                  disabled={disableSave}
                  onClick={handleAddWebhook}
                >
                  <Icon name='add' /> Add Glip Webhook
                </Button>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </Modal.Content>
      <Modal.Actions>
        <Button
          onClick={() => {
            setFields(initFields || [])
            setDisableSave(false)
          }}
          primary
        >
          <Icon name="undo" /> Restore
          </Button>
        <Button
          color="green"
          onClick={handleSave}
          disabled={isEqual(fields, initFields) || disableSave}
        >
          <Icon name="save" /> Save
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

export default GlipNotificationsModal